import { Link, LinkProps } from "react-router-dom";

import styles from "@components/typography/InternalLink.module.css";
import { Colors } from "@utils/colorUtils";

// react-router Link is automatically in the tab index, so don't let clients set it
type Props = Omit<LinkProps, "tabIndex"> & {
  color?: Extract<Colors, "white">;
  expand?: boolean;
  stylized?: boolean;
};

const InternalLink = ({ className, color, expand = false, stylized = true, ...otherAnchorProps }: Props) => {
  const classNames = [styles.reset];
  if (expand) classNames.push(styles.expand);
  if (stylized) classNames.push(styles.stylized);
  if (className) classNames.push(className);
  if (color) classNames.push(styles[color]);

  return <Link className={classNames.join(" ")} {...otherAnchorProps} />;
};

export default InternalLink;
